module.exports = __webpack_public_path__ + "static/media/fileCancelBtn.a9632a66.svg";